import { defineStore } from 'pinia';
import { cloneDeep } from 'lodash-es';
import type { MachineType, NewOrder, Order } from '../types/Order';
import { getDeliveryDate } from '../utils/date';
import { useHolidaysStore } from './holiday';

function getNewOrder(): NewOrder {
  const { holidays } = useHolidaysStore();
  return {
    id: 0,
    status: 'pending',
    file_ids: [],
    number_parts: 1,
    modeling: false,
    material_id: 0,
    color: '',
    type: '',
    delivery_time: getDeliveryDate({ date: new Date(), holidays }),
    machine_type: '3d',
    pickup: 'fromShop',
    address: null,
    price: 0,
    comment: '',
  };
}

export const useOrderStore = defineStore('orderStore', () => {
  const machineType = ref<MachineType>('3d');
  const order = ref<NewOrder | Order>(getNewOrder());
  const adminView = ref(false);
  const isPreviewMode = ref(false);
  const disabledPreview = computed(
    () => isPreviewMode.value && !adminView.value,
  );
  const isFetchingResourcess = ref(false);

  watch(machineType, (selectedMachineType) => {
    if (order.value.machine_type !== selectedMachineType) {
      order.value.machine_type = selectedMachineType;
    }
  });

  const resetStore = () => {
    order.value = getNewOrder();
    adminView.value = false;
    isPreviewMode.value = false;
  };

  const setPreviewOrder = (
    previewOrder: Order,
    conf: { adminView: boolean } = { adminView: false },
  ) => {
    order.value = cloneDeep(previewOrder);
    machineType.value = previewOrder.machine_type;
    adminView.value = conf.adminView;
    isPreviewMode.value = true;
  };

  const setFetchingResourcess = (state: boolean) => {
    isFetchingResourcess.value = state;
  };

  const setMachineType = (machine: MachineType) => {
    machineType.value = machine;
    order.value.machine_type = machine;
  };

  return {
    machineType,
    order,
    adminView,
    disabledPreview,
    isPreviewMode,
    isFetchingResourcess,
    resetStore,
    setPreviewOrder,
    setFetchingResourcess,
    setMachineType
  };
});
